"use client"

import { MessageSquareOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquareOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquareOffIcon = component(Icon)({ as: MessageSquareOff })
